var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-67f1c98d-8279-4bc4-9595-5be409619e8c",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60.4 61.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-38);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-12);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-17);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-19);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-33);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-57);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-21);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-42);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient-15);\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-14 {\r\n        fill: url(#linear-gradient-31);\r\n      }\r\n\r\n      .cls-15 {\r\n        fill: url(#linear-gradient-34);\r\n      }\r\n\r\n      .cls-16 {\r\n        fill: url(#linear-gradient-41);\r\n      }\r\n\r\n      .cls-17 {\r\n        fill: url(#linear-gradient-40);\r\n      }\r\n\r\n      .cls-18 {\r\n        fill: url(#linear-gradient-13);\r\n      }\r\n\r\n      .cls-19 {\r\n        fill: url(#linear-gradient-23);\r\n      }\r\n\r\n      .cls-20 {\r\n        fill: url(#linear-gradient-25);\r\n      }\r\n\r\n      .cls-21 {\r\n        fill: url(#linear-gradient-43);\r\n      }\r\n\r\n      .cls-22 {\r\n        fill: url(#linear-gradient-16);\r\n      }\r\n\r\n      .cls-23 {\r\n        fill: url(#linear-gradient-22);\r\n      }\r\n\r\n      .cls-24 {\r\n        fill: url(#linear-gradient-54);\r\n      }\r\n\r\n      .cls-25 {\r\n        fill: url(#linear-gradient-55);\r\n      }\r\n\r\n      .cls-26 {\r\n        fill: url(#linear-gradient-35);\r\n      }\r\n\r\n      .cls-27 {\r\n        fill: url(#linear-gradient-50);\r\n      }\r\n\r\n      .cls-28 {\r\n        fill: url(#linear-gradient-32);\r\n      }\r\n\r\n      .cls-29 {\r\n        fill: url(#linear-gradient-20);\r\n      }\r\n\r\n      .cls-30 {\r\n        fill: url(#linear-gradient-14);\r\n      }\r\n\r\n      .cls-31 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-32 {\r\n        fill: url(#linear-gradient-52);\r\n      }\r\n\r\n      .cls-33 {\r\n        fill: url(#linear-gradient-45);\r\n      }\r\n\r\n      .cls-34 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-35 {\r\n        fill: url(#linear-gradient-39);\r\n      }\r\n\r\n      .cls-36 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-37 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-38 {\r\n        fill: url(#linear-gradient-27);\r\n      }\r\n\r\n      .cls-39 {\r\n        fill: url(#linear-gradient-53);\r\n      }\r\n\r\n      .cls-40 {\r\n        fill: url(#linear-gradient-36);\r\n      }\r\n\r\n      .cls-41 {\r\n        fill: url(#linear-gradient-48);\r\n      }\r\n\r\n      .cls-42 {\r\n        fill: url(#linear-gradient-49);\r\n      }\r\n\r\n      .cls-43 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-44 {\r\n        fill: url(#linear-gradient-47);\r\n      }\r\n\r\n      .cls-45 {\r\n        fill: url(#linear-gradient-24);\r\n      }\r\n\r\n      .cls-46 {\r\n        fill: url(#linear-gradient-26);\r\n      }\r\n\r\n      .cls-47 {\r\n        fill: url(#linear-gradient-18);\r\n      }\r\n\r\n      .cls-48 {\r\n        fill: url(#linear-gradient-51);\r\n      }\r\n\r\n      .cls-49 {\r\n        fill: url(#linear-gradient-30);\r\n      }\r\n\r\n      .cls-50 {\r\n        fill: url(#linear-gradient-44);\r\n      }\r\n\r\n      .cls-51 {\r\n        fill: url(#linear-gradient-29);\r\n      }\r\n\r\n      .cls-52 {\r\n        fill: url(#linear-gradient-46);\r\n      }\r\n\r\n      .cls-53 {\r\n        fill: url(#linear-gradient-28);\r\n      }\r\n\r\n      .cls-54 {\r\n        fill: url(#linear-gradient-56);\r\n      }\r\n\r\n      .cls-55 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-56 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-57 {\r\n        fill: url(#linear-gradient-37);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 11.7,
    y1: 711.3,
    x2: 16.1,
    y2: 711.3,
    gradientTransform: "translate(0 -656)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 45.5,
    y1: 704.4,
    x2: 49.9,
    y2: 704.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 46.4,
    y1: 696,
    x2: 50.5,
    y2: 696,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 4,
    y1: 703,
    x2: 7.6,
    y2: 703,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0,
    y1: 686.6,
    x2: 1.4,
    y2: 686.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 679.1,
    x2: 1.4,
    y2: 679.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 37.5,
    y1: 686.6,
    x2: 42.3,
    y2: 686.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: 694.1,
    x2: 1.4,
    y2: 694.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 44.2,
    y1: 711.4,
    x2: 48.6,
    y2: 711.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 52.7,
    y1: 703,
    x2: 56.3,
    y2: 703,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 20.8,
    y1: 716.3,
    x2: 24.7,
    y2: 716.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 46.3,
    y1: 677.3,
    x2: 50.5,
    y2: 677.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 28.2,
    y1: 716.5,
    x2: 32.1,
    y2: 716.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 35.6,
    y1: 716.2,
    x2: 39.6,
    y2: 716.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 45.5,
    y1: 668.8,
    x2: 49.9,
    y2: 668.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 44.2,
    y1: 661.9,
    x2: 48.6,
    y2: 661.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 52.7,
    y1: 670,
    x2: 56.3,
    y2: 670,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 27.9,
    y1: 656.7,
    x2: 32.5,
    y2: 656.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 35.6,
    y1: 657,
    x2: 39.6,
    y2: 657,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 58.8,
    y1: 679.1,
    x2: 59.9,
    y2: 679.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 58.9,
    y1: 686.6,
    x2: 60.4,
    y2: 686.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 4,
    y1: 670.1,
    x2: 7.6,
    y2: 670.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 53.8,
    y1: 695.1,
    x2: 56.8,
    y2: 695.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 54,
    y1: 686.7,
    x2: 56.8,
    y2: 686.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 53.8,
    y1: 677.9,
    x2: 56.8,
    y2: 677.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 20.8,
    y1: 657,
    x2: 24.7,
    y2: 657,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 11.7,
    y1: 661.9,
    x2: 16.1,
    y2: 661.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 46.6,
    y1: 686.6,
    x2: 50.6,
    y2: 686.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 37.3,
    y1: 696.3,
    x2: 42.2,
    y2: 696.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 27.8,
    y1: 667.9,
    x2: 32.5,
    y2: 667.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 27.7,
    y1: 676.7,
    x2: 32.6,
    y2: 676.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 28,
    y1: 712.2,
    x2: 32.3,
    y2: 712.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 19.4,
    y1: 661.1,
    x2: 24,
    y2: 661.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 19.4,
    y1: 712.1,
    x2: 24,
    y2: 712.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 28,
    y1: 661,
    x2: 32.3,
    y2: 661,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 27.8,
    y1: 705.2,
    x2: 32.5,
    y2: 705.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 27.7,
    y1: 686.5,
    x2: 32.6,
    y2: 686.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 27.7,
    y1: 696.4,
    x2: 32.6,
    y2: 696.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 36.3,
    y1: 712,
    x2: 40.9,
    y2: 712,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 36.9,
    y1: 704.9,
    x2: 41.8,
    y2: 704.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 36.3,
    y1: 661.1,
    x2: 40.9,
    y2: 661.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 18.5,
    y1: 705.1,
    x2: 23.4,
    y2: 705.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 37.3,
    y1: 676.8,
    x2: 42.2,
    y2: 676.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 36.9,
    y1: 668.1,
    x2: 41.8,
    y2: 668.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 3.5,
    y1: 686.5,
    x2: 6.3,
    y2: 686.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 3.5,
    y1: 678.1,
    x2: 6.5,
    y2: 678.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 9.8,
    y1: 677.1,
    x2: 13.9,
    y2: 677.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 9.7,
    y1: 686.5,
    x2: 13.7,
    y2: 686.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 18.1,
    y1: 696.3,
    x2: 22.9,
    y2: 696.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 3.5,
    y1: 695.2,
    x2: 6.5,
    y2: 695.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 58.8,
    y1: 694.2,
    x2: 59.9,
    y2: 694.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 9.8,
    y1: 695.8,
    x2: 13.9,
    y2: 695.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 18.5,
    y1: 668.2,
    x2: 23.4,
    y2: 668.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 18.1,
    y1: 676.8,
    x2: 23,
    y2: 676.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 18,
    y1: 686.6,
    x2: 22.8,
    y2: 686.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 10.4,
    y1: 704.4,
    x2: 14.8,
    y2: 704.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 10.4,
    y1: 668.8,
    x2: 14.8,
    y2: 668.8,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-7ae8c3e2-70e6-4018-a567-1c111f03b87c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M15.6,55.2c-.1-.3-.1-.7-.2-1.1-.5,0-.9-.2-1.3-.2-.4,0-.8,0-1.1-.2s-.8,0-1.3-.2c.1.4.2.8.3,1.1.1.2.1.4.1.5.8.6,1.7,1.2,2.6,1.8h.1c.4,0,.8,0,1.3.2-.1-.4-.2-.7-.2-1s-.2-.6-.3-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M47.4,46.5c-.4,0-.9,0-1.4.2,0,.6,0,1-.2,1.4,0,.4,0,.8-.2,1.2,0,.4,0,.8-.2,1.3.5,0,1-.2,1.4-.2.4,0,.8,0,1.2-.2s.8,0,1.3-.2c0-.5.2-.9.2-1.3,0-.4,0-.8.2-1.2,0-.4,0-.8.2-1.4-.5,0-.9,0-1.3.2-.4,0-.8.1-1.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M48,37.6c-.4,0-.9,0-1.4,0v3.5c0,.4,0,.8,0,1.2.6,0,1,0,1.4,0s.8,0,1.2,0,.8,0,1.3,0v-4.4c-.5,0-.9,0-1.3,0s-.7-.2-1.1-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M7.2,46.8c0-.4-.2-.8-.3-1.3-.4,0-.8-.2-1.1-.2-.3,0-.6,0-.9-.2s-.6-.2-1-.3c0,.5,0,.9.2,1.3h0c.6,1,1.2,1.9,1.9,2.8.2,0,.3,0,.5,0,.3,0,.7.2,1.1.3,0-.5-.2-.9-.2-1.3s-.2-.8-.2-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1.4,32.5v-3.9c-.4,0-.6.1-.8.1s-.4,0-.5.1c0,.6,0,1.2,0,1.8s0,1.2.1,1.8c.2,0,.3,0,.5,0h.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M.6,25c.2-.1.4-.1.8-.2v-3.6c-.4,1.3-.7,2.5-.8,3.8q-.1,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M42.3,28.1h-4.8v4.9h4.8v-4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1.4,37.8v-1.4c-.4,0-.6-.2-.8-.2h0c.2,1.2.5,2.5.9,3.8v-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M46.2,53.9c-.4,0-.8,0-1.3.2,0,.4-.2.8-.2,1.1,0,.3,0,.6-.2.9,0,.3-.2.6-.2,1,.5,0,.9,0,1.3-.2h.2c.3,0,.6,0,.9,0,.4,0,.8,0,1.2-.2,0-.4.2-.7.3-1,0,0,0-.2,0-.3,0-.2,0-.4.2-.6,0-.3.2-.7.3-1.1-.5,0-.9.2-1.3.2-.6-.1-.9,0-1.3,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M54.5,45.3c-.3,0-.7.2-1.1.2,0,.5-.2.9-.2,1.3,0,.4,0,.8-.2,1.2,0,.4,0,.8-.2,1.3.4,0,.8-.2,1.1-.3.2,0,.4,0,.6-.2.6-.8,1.1-1.6,1.6-2.5v-.3c0-.4,0-.8.2-1.3-.4,0-.7.2-1,.3-.2,0-.5.2-.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M24.4,59.8h-3.6c1.2.4,2.5.7,3.8,1h0c0-.4,0-.6-.2-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.8,18.9c-.4,0-.9-.1-1.4-.1,0,.5,0,.9,0,1.2v3.5c.5,0,1,.1,1.4.1s.8,0,1.2.1c.4,0,.8.1,1.3.1v-4.4c-.5-.1-.9-.1-1.3-.1-.5-.3-.9-.3-1.3-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M29.6,59.8h-1.3c0,.4.1.6.1.8s0,.4.1.5c.6,0,1.2,0,1.8,0h1.7c0-.2,0-.3,0-.5s0-.5,0-.8h-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M37.2,59.7h-1.3c0,.4-.2.6-.2.9h0c1.3-.1,2.7-.5,4-.9h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M46.8,10.8c-.4-.1-.8-.1-1.4-.2,0,.5,0,.9.2,1.3,0,.4,0,.8.2,1.2,0,.4,0,.9.2,1.4.5.1,1,.1,1.4.2s.8.1,1.2.2c.4.1.8.1,1.3.2,0-.5,0-1-.2-1.4,0-.4,0-.8-.2-1.2,0-.4,0-.8-.2-1.3-.5-.1-.9-.2-1.3-.2s-.8-.2-1.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M44.6,6c0,.3.2.7.2,1.1.5,0,.9.2,1.3.2.4,0,.8,0,1.1.2.4,0,.8.2,1.3.2,0-.4-.2-.8-.3-1.1,0-.2,0-.4-.2-.6-.8-.6-1.6-1.2-2.5-1.7h-.2c-.4,0-.8,0-1.3-.2,0,.4.2.7.2,1,.3.2.4.5.4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.1,14.3c0,.4,0,.8.2,1.3.4.1.8.2,1.1.2.3.1.6.1.9.2.3.1.6.2,1,.3,0-.5,0-.9-.2-1.3v-.2c-.5-.9-1.1-1.7-1.7-2.5-.2-.1-.4-.1-.6-.2-.3-.1-.7-.2-1.1-.3,0,.5.2.9.2,1.3s0,.8.2,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M28.3.6c0,.2,0,.4-.1.8h3.8c0-.3,0-.5,0-.7s0-.4-.1-.6h.6c-.8,0-1.5,0-2.3,0s-1.5,0-2.3.1h.5c0,.2-.1.4-.1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.9,1.5h3.7c-1.3-.4-2.6-.8-4-1q0,.1,0,.2c0,.2,0,.4.2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M58.9,23.4v1.4c.4.1.6.2.8.2s0,0,.2.1c-.2-1.4-.6-2.8-1-4.1v2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M60.4,30.6c0-.8,0-1.6,0-2.4v.6c-.2,0-.4-.1-.6-.1s-.4,0-.8-.1v4c.4,0,.6,0,.8,0,.2,0,.4,0,.6,0v.6c0-.8,0-1.6,0-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M6,12.3c-.7.9-1.2,1.8-1.8,2.7h0c0,.4,0,.8-.2,1.3.4-.1.7-.2,1-.3.3,0,.6,0,.9,0s.7-.1,1.1-.2c0-.5.2-.9.2-1.3,0-.4,0-.8.2-1.1,0-.4,0-.8.2-1.3-.4.1-.8.2-1.1.3-.2,0-.3,0-.5,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M55,37c-.3,0-.6,0-1.1,0v4.4c.4,0,.8,0,1.1-.2s.6,0,.9-.2c.3,0,.6,0,.9-.2v-4.2c-.3,0-.6,0-.9,0s-.6.2-.9.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M56.8,28.5h-2.9v4.4h2.9v-4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M54.9,19.8c-.3-.1-.7-.1-1.1-.2v4.3c.4,0,.8.1,1.1.1s.6.1.9.1.6.1.9.1v-4.2c-.3-.1-.6-.1-.9-.2-.4.1-.6.1-.9,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M21.9,1.5h2.5c.1-.4.2-.6.2-.8s0-.1.1-.2c-1.3.2-2.6.6-3.9,1h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M14.8,4.3c-.9.6-1.8,1.2-2.6,1.8,0,.2-.1.3-.1.5-.1.3-.2.7-.3,1.1.5,0,.9-.2,1.3-.2.4,0,.7,0,1.1-.2.4,0,.8,0,1.3-.2.1-.4.2-.8.2-1.1s.1-.6.2-.9.2-.6.2-1c-.5,0-.9,0-1.3.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M50.5,28.2h-3.9v4.8h3.9v-4.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M39.9,37.9h-2.4v4.8h3.5c.4,0,.8,0,1.2,0,0-.5,0-.9,0-1.2v-3.5h-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M30.1,13.9h2.4v-3.9h-4.6v3.9h2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M30.1,23.1h2.4v-4.8h-4.8v4.8h2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M30.1,54.7h-2.2v2.9h4.2v-2.9h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21.5,6.6h2.2c0-.4.1-.8.1-1.1s.1-.6.1-.9,0-.7,0-1h-4.1c-.1.3-.1.7-.2.9-.1.3-.1.6-.2.9s-.1.7-.2,1.1h1.1c.5,0,.8,0,1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M22,57.5h2.1c0-.3-.1-.7-.1-.9,0-.3-.1-.6-.1-.9s-.1-.7-.1-1.1h-4.3c.1.4.1.8.2,1.1s.1.6.2.9c.1.3.1.6.2,1h1.1c.3,0,.4,0,.8,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M32.2,3.6h-4.2v2.9h4.4v-2c-.1-.3-.2-.6-.2-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M30.1,47.3h-2.4v3.9h4.5v-3.9h-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M32.6,29.4v-1.4h-4.9v5.1h4.9v-1.4s0-2.3,0-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.1,38h-2.4v4.8h4.8v-4.8h-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M38.8,54.6h-2.2c0,.4,0,.8,0,1.1s0,.6,0,.9,0,.6,0,.9h4.1c0-.3,0-.7.2-1,0-.3,0-.6.2-.9,0-.3,0-.7.2-1.1h-1.1c-.5,0-.8,0-1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M39.5,47.1h-2.3c0,.6,0,1,0,1.4,0,.4,0,.8,0,1.2s0,.8,0,1.3h4.4c0-.5,0-1,0-1.4s0-.8,0-1.2,0-.9,0-1.5c-.5,0-.8,0-1.2,0s-.6.1-.9.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M38.3,3.7h-2.1c0,.3,0,.6,0,.9s0,.6,0,.9,0,.7,0,1.1h4.3c0-.4,0-.8-.2-1.1,0-.3,0-.6-.2-.9s0-.6-.2-.9h-1.1c0,0-.5,0-.8,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M21.1,51.1h2.2c0-.5-.1-.9-.1-1.3s0-.8-.1-1.2c0-.4,0-.9-.1-1.4h-3.4c-.4,0-.8,0-1.2,0,0,.6.1,1,.1,1.5s.1.8.1,1.2.1.8.1,1.4h1.2c.5-.1.9-.1,1.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M39.7,18.4h-2.4v4.8h4.7v-3.5c0-.4,0-.8,0-1.2-.5,0-.9,0-1.2-.1-.3,0-.6,0-1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M39.2,10h-2.2c0,.5,0,.9,0,1.3s0,.8,0,1.2c0,.4,0,.9,0,1.4h2.3c.3,0,.7,0,1,.1s.8,0,1.2.1c0-.6,0-1,0-1.4s0-.8,0-1.2,0-.8,0-1.4c-.4,0-.8,0-1.2-.1-.5,0-.8,0-1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M5.3,32.7h1.1v-4.4h-2.9v4.1h.9c.3.3.5.3.9.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M5.3,24.1c.3,0,.7-.1,1.1-.1v-4.3c-.4.1-.8.1-1.1.2-.3.1-.6.1-.9.2s-.4,0-.8.1v4.2c.3,0,.6-.1.9-.1.3-.1.5-.2.8-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M12.3,23.5c.4,0,.9,0,1.4-.1v-3.5c0-.4,0-.8.1-1.2-.6,0-1,.1-1.4.1s-.7.2-1.1.2-.8.1-1.3.1c0,.4,0,.8-.1,1.2v3.2c.5,0,.9-.1,1.3-.1.4.2.7,0,1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M12.2,32.9h1.4v-4.8h-3.9v4.6h1.3c.4.2.8.2,1.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M20.6,42.7h2.4v-4.8h-4.8v3.5c0,.4,0,.8.1,1.2.5,0,.9,0,1.2,0s.7,0,1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M5.4,41.3c.3,0,.7,0,1.1.2v-4.4c-.4,0-.8,0-1.1,0s-.7,0-1,0-.6,0-.9,0v4.2c.3,0,.6,0,.9.2s.7,0,1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M58.9,36.4v3.9c.5-1.3.8-2.7,1-4.2q0,0-.2,0c-.2,0-.4,0-.8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M12.5,42.2c.4,0,.9,0,1.4,0,0-.5,0-.9-.1-1.2s0-.7,0-1.1v-2.4c-.6,0-1,0-1.4,0-.4,0-.8,0-1.2,0-.4,0-.8,0-1.3,0v3.2c0,.4,0,.8.1,1.2.5,0,.9,0,1.3,0,.4.3.8.4,1.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M20.8,14h2.3c0-.6,0-1,.1-1.4,0-.4,0-.8.1-1.2,0-.4.1-.8.1-1.3h-3.2c-.4,0-.7,0-1.2.1-.1.5-.1.9-.1,1.4s-.1.8-.1,1.2-.1.9-.1,1.4c.5,0,.8,0,1.2-.1s.6,0,.9,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M20.4,23.2h2.4v-4.8h-3.5c-.4,0-.8,0-1.2.1,0,.5,0,.9-.1,1.2v3.5h1.2c.3,0,.9,0,1.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M20.4,33h2.4v-4.9h-4.8v4.8h1.3c.3,0,.7,0,1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M13.4,50.4c.4,0,.8,0,1.4.2-.1-.5-.1-.9-.2-1.3s-.1-.8-.2-1.2c-.1-.4-.1-.9-.2-1.4-.6,0-1,0-1.4-.2s-.8,0-1.2-.2c-.4,0-.8,0-1.3-.2.1.5.1,1,.2,1.4s.1.8.2,1.2c.1.4.1.8.2,1.3.5,0,.9.2,1.3.2s.9,0,1.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M12.9,14.7c.4-.1.9-.1,1.4-.2.1-.6.1-1,.2-1.4.1-.4.1-.8.2-1.2.1-.4.1-.8.2-1.3-.5.1-1,.1-1.4.2-.4.1-.8.1-1.2.2-.4.1-.8.1-1.3.2-.1.5-.2.9-.2,1.3s-.1.8-.2,1.2c-.1.4-.1.8-.2,1.4.5-.1.9-.1,1.3-.2s.8-.2,1.2-.2h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.723cbfb8080854475d39422da32b4d52.svg";
export { ForwardRef as ReactComponent };